export enum FEATURE_TOGGLES {
    EXTRA_DOCUMENT = 'ExtraDocument',
    CBL_COSTANDREVENUE = 'CBL-AddCostRevenue',
    RESEND_LAST_MESSAGE = 'FINOPS_RESEND_LAST_MESSAGE',
    FINOPS_DOWNLOAD_COMPARED_RATES = 'FINOPS_DOWNLOAD_COMPARED_RATES',
    FINOPS_BULK_UPLOAD_CHARGES_IMPORT = 'FINOPS_BULK_UPLOAD_CHARGES_IMPORT',
    FINOPS_BULK_UPLOAD_CHARGES_EXPORT = 'FINOPS_BULK_UPLOAD_CHARGES_EXPORT',
    FINOPS_RESET_ERROR_LOG_REPROCESS = 'FINOPS_RESET_ERROR_LOG_REPROCESS',
    FINOPS_BULK_DOWNLOAD_CHARGES = 'FINOPS_BULK_DOWNLOAD_CHARGES',
    FINOPS_BULK_DOWNLOAD_CHARGES_EXPORTJOB = 'FINOPS_BULK_DOWNLOAD_CHARGES_EXPORTJOB',
    FINOPS_BULK_SELECT_FOR_DOWNLOAD = 'FINOPS_BULK_SELECT_FOR_DOWNLOAD',
    FINOPS_AMENDMENT_OF_ATHENA_CONTRACTUAL_CHARGES = 'FINOPS_AMENDMENT_OF_ATHENA_CONTRACTUAL_CHARGES',
    SAPJobCloseNotification = 'SAPJobCloseNotification',
    ENABLE_PASSTHROUGH = 'FINOPS_ENABLE_PASSTHROUGH_AMENDMENT_FROM_UI',
    FINOPS_BKS_EXTRA_DOC = 'FINOPS_BKS_EXTRA_DOC',
    FINOPS_DCS_EXTRA_DOC = 'FINOPS_DCS_EXTRA_DOC',
    FINOPS_RECONCILIATION = 'FINOPS_RECONCILIATION',
    FINOPS_ENABLE_VATPARTNER_AMENDMENT = 'FINOPS_ENABLE_VATPARTNER_AMENDMENT',
    FINOPS_FCR_COMMERCIAL_INV_CONSUMPTION = 'FINOPS_FCR_COMMERCIAL_INV_CONSUMPTION',
    FINOPS_NFTP_INTEGRATION = 'FINOPS_NFTP_INTEGRATION',
    FINOPS_WEBAPI_REQUEST_NOTIFICATION = 'FINOPS_WEBAPI_REQUEST_NOTIFICATION',
    FINOPS_WEBAPI_NOTIFICATION_LOGS = 'FINOPS_WEBAPI_NOTIFICATION_LOGS',
    FINOPS_WEBAPI_INTERFACE_LOGS = 'FINOPS_WEBAPI_INTERFACE_LOGS',
    FINOPS_WEBAPI_REPROCESS_LOGS = 'FINOPS_WEBAPI_REPROCESS_LOGS',
    FINOPS_WEBAPI_IMPORT_CHARGE_ITEMS_AUDIT_LOG = 'FINOPS_WEBAPI_IMPORT_CHARGE_ITEMS_AUDIT_LOG',
    FINOPS_AUTO_PRICE_RETRIEVAL_FROM_ATHENA = 'FINOPS_AUTO_PRICE_RETRIEVAL_FROM_ATHENA',
    FINOPS_WEBAPI_EXPORT_JOB_BOOKINGS = 'FINOPS_WEBAPI_EXPORT_JOB_BOOKINGS',
    FINOPS_WEBAPI_EXPORT_JOB_COST_REVENUE_SPLITS = 'FINOPS_WEBAPI_EXPORT_JOB_COST_REVENUE_SPLITS',
    FINOPS_WEBAPI_EXPORT_JOB_CBL = 'FINOPS_WEBAPI_EXPORT_JOB_CBL',
    FINOPS_WEBAPI_EXPORT_JOB_CLR = 'FINOPS_WEBAPI_EXPORT_JOB_CLR',
    FINOPS_WEBAPI_EXPORT_JOB_ETS = 'FINOPS_WEBAPI_EXPORT_JOB_ETS',
    FINOPS_WEBAPI_EQUIPMENT_DETAILS = 'FINOPS_WEBAPI_EQUIPMENT_DETAILS',
    FINOPS_AIR = 'FINOPS_AIR',
    FINOPS_ATHENA_PAYTOPARTY_FOR_ADHOC_CONTRACTUAL_RATE_DERIVATION = 'FINOPS_ATHENA_PAYTOPARTY_FOR_ADHOC_CONTRACTUAL_RATE_DERIVATION',
    FINOPS_FINANCE_OUTBOUND_REQUESTS = 'FINOPS_FINANCE_OUTBOUND_REQUESTS',
    SHOW_PENDING_PROCESSING_MESSAGES = 'SHOW_PENDING_PROCESSING_MESSAGES',
    FINOPS_NFTP_SALESORDER_REQ_EXPORT = 'FINOPS_NFTP_SALESORDER_REQ_EXPORT',
    FINOPS_NFTP_SALESORDER_REQ_IMPORT = 'FINOPS_NFTP_SALESORDER_REQ_IMPORT',
    FINOPS_ALLOW_NEGATIVE_RATE = 'FINOPS_ALLOW_NEGATIVE_RATE',
    FINOPS_ATHENA_BULK_UPLOAD_REFRESH = 'FINOPS_ATHENA_BULK_UPLOAD_REFRESH',
    FINOPS_ROAD_RAIL = 'FINOPS_ROAD_RAIL',
    FINOPS_ICP_AUTOMATION = 'FINOPS_ICP_AUTOMATION',
    FINOPS_ICP_VAT_PARTNER_DETERMINATION = 'FINOPS_ICP_VAT_PARTNER_DETERMINATION',
    FINOPS_PRE_INVOICE_VALIDATION = 'FINOPS_PRE_INVOICE_VALIDATION',
    FINOPS_NFTP_ROE = 'FINOPS_NFTP_ROE',
    FINOPS_ATHENA_ADDITIONAL_INCOTERMS = 'FINOPS_ATHENA_ADDITIONAL_INCOTERMS',
    IMPORT_MCI_CHARGE_ENABLED = 'IMPORT_MCI_CHARGE_ENABLED',
    EXPORT_MCI_CHARGE_ENABLED = 'EXPORT_MCI_CHARGE_ENABLED',
    FINOPS_CHARGE_SPLIT_ENABLED = 'FINOPS_CHARGE_SPLIT_ENABLED',
    FINOPS_KMART_WSI_NON_STANDARD_FCR = 'FINOPS_KMART_WSI_NON_STANDARD_FCR',
    FINOPS_BPD_ENGINE = 'FINOPS_BPD_ENGINE',
    FINOPS_EXCEPTION_MANAGEMENT_UI = 'FINOPS_EXCEPTION_MANAGEMENT_UI',
    FINOPS_HBL_CONSUMPTION = 'FINOPS_HBL_CONSUMPTION',
    FINOPS_RECEIVING_FCR = 'FINOPS_RECEIVING_FCR',
}
